/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

import { Table__header, Table__row, Table__footer } from "components/table/table";
import { AppContext } from "context/appContext";
import { ContentContext } from "context/contentContext";

/**
 * styled components
 */

const Container = styled.div``;
const Body = styled.div``;

/**
 * table component is..
 */

const Table__table = ({ data }) => {
  const { t, getFilterByTitle } = useContext(AppContext);
  const { lang } = useContext(ContentContext);
  if (!data.length > 0) return null;
  const sample = data[0].specs;
  const rows = Object.keys(sample);
  const blacklistPrice = ["it"];
  const blacklisted = blacklistPrice.includes(lang);
  return (
    <Container>
      <Table__header data={data} />
      <Body>
        {rows.map((row, index) => {
          const { tooltip } = getFilterByTitle(row);
          if (blacklisted && row === "price") return null;
          return (
            <Table__row
              data={data}
              content={row}
              title={t(row)}
              index={index}
              key={index}
              tooltip={tooltip}
            />
          );
        })}
      </Body>
      <Table__footer data={data} />
    </Container>
  );
};

export default Table__table;

Table__table.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Table__table.defaultProps = {
  style: {},
};

/*
    import Table__table from 'components/table/table/table__table'
    <Table__table />
  */
